<template>
  <div class="container">
    <PublicHeader />
    <!-- 输入框 -->
    <div class="content">
      <!-- 绑定邮箱 -->
      <div class="tit">{{ $t('safe').Bindmailbox }}</div>
      <!-- 电子邮箱-->
      <div class="item">
        <van-field v-model="Email" :placeholder="$t('register').Mailbox"></van-field>
      </div>
      <!-- 验证码 -->
      <div class="item">
        <van-field v-model="Captcha" :placeholder="$t('register').Captcha">
          <template #right-icon>
            <span style="color: var(--primary_color)" @click="getCaptchaCode" v-if="countDownSec === 60">{{ tips
              }}</span>
            <span v-else style="color: var(--ntext_color)">{{ countDownSec }} s</span>
          </template>
        </van-field>
      </div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('forgotPass').btn }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      Email: '',//邮箱
      Captcha: '', //验证码
      uuid: '',//验证码token
      tips: this.$t('register').send,//发送验证码信息
      countDownSec: 60,
      timer: null,
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
  },
  methods: {
    //获取验证码
    async getCaptchaCode() {
      if (this.timer) return
      // 邮箱
      if (!this.Email) {
        this.$toast(this.$t('register').placeholder5)
        return false
      }
      const reg = new RegExp(
        '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$'
      )
      if (!reg.test(this.Email.toLowerCase())) {
        this.$toast(this.$t('register').emaiError)
        return false
      }
      this.sendCode()
    },
    //发送验证码
    async sendCode() {
      this.countDownSec--
      this.timer = setInterval(() => {
        this.countDownSec--
        if (this.countDownSec === 0) {
          this.countDownSec = 60
          this.tips = this.$t('register').Resend
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
      const pRes = await userApi.sendCode({
        type: 'Email',
        email: this.Email
      })
      this.$toast({ message: this.$t('register').sendSuccess })
      this.uuid = pRes.uuid
    },
    // 提交
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        email: this.Email,
        uuid: this.uuid,
        captcha: this.Captcha,
      }
      await userApi.bindEmail(form)
      this.$toast(this.$t('forgotPass').success)
      this.$router.go(-1)
    },
    // 表单验证
    checkForm() {
      // 邮箱
      if (!this.Email) {
        this.$toast({
          message: this.$t('register').placeholder5,
          position: 'center'
        })
        return false
      }
      // 验证码
      if (!this.Captcha) {
        this.$toast({
          message: this.$t('register').placeholder4,
          position: 'center'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 15px;
  background: var(--background_color);

  .content {
    .tit {
      margin-top: 45px;
      font-size: 25px;
      font-weight: bold;
      color: var(--primary_color);
    }
    .item {
      margin-top: 20px;

      .select_btn {
        font-size: 14px;
        color: var(--text_color);
        margin-right: 10px;
        display: flex;
        align-items: center;

        .ric {
          transform: rotate(90deg);
          margin: 0 10px 0 5px;
        }

        .line {
          height: 15px;
          background: var(--ntext_color);
          width: 1px;
        }
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--primary_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: #fff;
    }

    .footer {
      position: fixed;
      bottom: 30px;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
        font-weight: bold;
      }
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid var(--info_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}

::v-deep .van-tab {
  font-size: 15px;
  justify-content: left;
}

::v-deep .van-tab--active {
  font-weight: bold;
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 14px;
}
</style>
